module.exports = __webpack_public_path__ + "img/rank-1.07be4514.png";